import alt from 'components/Dispatcher';
import {browserHistory} from 'react-router';
import API from 'sources/API';

class BusinessActions {
    setLoading(loading) {
        return loading;
    }
    // 更新 Business 详情
    updateBusiness(business) {
        return business;
    }
    postBusiness(business) {
        return business;
    }
    // 更新 offset
    updateBusinessOffset(offset) {
        return offset;
    }
    // 获取 Business 详情
    fetchBusiness(id) {
        return id;
    }
    // 追加 BusinessList
    updateBusinessList(businessList) {
        return businessList;
    }
    // 更新全部 BusinessList
    updateAllBusinessList(businessList) {
        return businessList;
    }
    updateArticles(articles){
        return articles;
    }
    fetchArticles(id){
        return id;
    }
    // 获取更多 Business
    fetchBusinessList(id) {
        return id;
    }
    clearBusiness() {
        return true;
    }
    clearArticles() {
        return true;
    }
    postBusinessSuccess(json){
        if(json.status === 0){
            this.updateBusiness(json.result)
            browserHistory.goBack()
        }else{
            this.fetchFailed(json);
        }
        return json;
    }
    // 请求成功后统一回调
    fetchSuccess(res) {
        if(res.status === 0) {
            this[res.updateFnName](res.result);
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    // 请求失败后统一回调
    fetchFailed(err) {
        console.log(err);
        if(err.status === 401) {
            if(API.isWechat) {
                location.href = API.redirectWechatLogin;
            } else {
                browserHistory.push('/login');
            }
        }
        return err;
    }
}

export default alt.createActions(BusinessActions);



// WEBPACK FOOTER //
// ./src/actions/BusinessActions.js